import React from "react";
import "../../styles/VisionMission.css";
import {
  FaHandsHelping,
  FaNetworkWired,
  FaRocket,
  FaComments,
} from "react-icons/fa";

const VisionMission = () => {
  return (
    <div className="vision-mission-section py-5 bg-light text-center">
      <div className="container">
        <h1 className="wise-secondary-gradient vision-subheading text-warning">
          About Us
        </h1>
        <h2 className="text-secondary text-dark mb-3">
          Unveiling Our Identity, Vision and Values
        </h2>
        <p className="text-secondary mx-auto description-text">
          WISE is network of students, professionals, and industry leaders
          working together to empower women in semiconductors and electronics.
          We aim to address underrepresentation, bridge opportunity gaps, and
          create pathways for leadership, innovation.
        </p>

        {/* Vision and Mission Cards in same row */}
        <div className="row g-4 mt-5">
          {/* Vision Card */}
          <div className="col-md-6">
            <div className="hover-effect-only h-100 p-4 border-0 rounded-4 bg-light text-start">
              <h1 className=" vision-subheading text-warning">
                Our Vision
              </h1>
              <h3 className="text-secondary fw-200 mt-2">
                Empowering Lives Through Education
              </h3>
              <p className="text-secondary mx-auto description-text">
                To build an inclusive, supportive, and thriving ecosystem where
                women in semiconductors are equally represented, celebrated, and
                equipped to lead.
              </p>
            </div>
          </div>

          {/* Mission Card */}
          <div className="col-md-6">
            <div className="hover-effect-only h-100 p-4 border-0 rounded-4 bg-light text-start">
              <h1 className="vision-subheading text-warning">
                Our Mission
              </h1>
              <h3 className="text-secondary mt-2">
                Learning for All, Everywhere
              </h3>
              <ul className="text-secondary mt-3 ps-3">
                <li>Provide mentorship and leadership opportunities</li>
                <li>
                  Enable networking across academia, startups, and global
                  companies
                </li>
                <li>
                  Amplify women's voices and achievements in semiconductors
                </li>
                <li>
                  Deliver skill-building initiatives through training, events,
                  and workshops
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Why WiSE Section */}
        <div className="mt-5 text-start">
          <h1 className="wise-secondary-gradient vision-subheading text-warning mb-2">
            Why WiSE?
          </h1>
          <p className="text-secondary why-wise-text">
            WiSE is designed to bridge the gaps by creating a vibrant, inclusive
            platform that serves as a powerful catalyst for visibility,
            connection, mentorship, and career advancement. We are building a
            vibrant, inclusive community where women can: Access valuable
            resources, including job opportunities, training, and educational
            content. Engage in mentorship, both as mentees and as leaders
            guiding the next generation. Tell their stories and learn from
            peers. Connect with peers, mentors, and allies across academia,
            startups, and industry giants and collaborate. Participate in events
            that aim towards career acceleration.
          </p>
        </div>

        {/* Why WiSE Cards */}
        <div className="row g-4 mt-4">
          {/* Card 1 */}
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100 d-flex flex-column justify-content-between p-4 rounded-4 shadow-sm why-wise-card">
              <div>
                <FaHandsHelping size={36} className="mb-3" />
                <h6 className="text-uppercase mb-3">Empowering Women</h6>
                <p>
                  Building a strong community to empower women in semiconductors
                  and electronics through mentorship and leadership.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100 d-flex flex-column justify-content-between p-4 rounded-4 shadow-sm why-wise-card">
              <div>
                <FaNetworkWired size={36} className="mb-3" />
                <h6 className="text-uppercase mb-3">Inclusive Networking</h6>
                <p>
                  Connecting students, professionals, and industry leaders
                  across academia and companies to foster collaboration.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100 d-flex flex-column justify-content-between p-4 rounded-4 shadow-sm why-wise-card">
              <div>
                <FaRocket size={36} className="mb-3" />
                <h6 className="text-uppercase mb-3">Career Advancement</h6>
                <p>
                  Providing training, workshops, and events to build skills
                  necessary for career growth and innovation.
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-3">
            <div className="card bg-primary text-white h-100 d-flex flex-column justify-content-between p-4 rounded-4 shadow-sm why-wise-card">
              <div>
                <FaComments size={36} className="mb-3" />
                <h6 className="text-uppercase  mb-3">Wellness & Mentorship</h6>
                <p>
                  Offering resources, job opportunities, and mentorship to help
                  women accelerate their careers in tech.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMission;
